import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Icon from "material-ui-next/Icon";

import style from "./style";

import { DescriptionField, If } from "components/support";

class CompanyIntegrationsTrayView extends Component {
  render() {
    const { className, company } = this.props;
    const { url, enabled } = (company.integrations || {}).tray || {};

    return (
      <div className={`${className} grid-container`}>
        <Row>
          <Col xs={12}>
            <div className="grid-container mt-sm mb-sm">
              <Typography type="headline">Tray</Typography>
              <hr />
              <Row bottom="xs">
                <Col xs={12}>
                  <DescriptionField label="URL da Loja" value={url} />
                </Col>
              </Row>
              <Row>
                <div className="integration-status">
                  <If test={enabled}>
                    <Icon className="done-icon">done</Icon>
                    <span className="icon-span">Integração Ativa</span>
                  </If>
                  <If test={!enabled}>
                    <Icon className="close-icon">close</Icon>
                    <span className="icon-span">Integração Inativa</span>
                  </If>
                </div>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default style(CompanyIntegrationsTrayView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/tray/index.jsx